import e from "@dialpad/dialtone-tokens/layered/themes/tokens-117-colors.css?inline";
//#region themes/117.js
var t = { brand: {
	css: e,
	name: "117"
} };
//#endregion
export { t as default };
